interface BreakPoint {
  min: number;
  max: number;
  id: string;
}

interface IsScoreWithinBreakpointProps {
  breakpoints: BreakPoint[];
  breakpoint: BreakPoint;
  rangeValue: number;
}

export function isScoreWithinBreakpoint({ breakpoints, breakpoint, rangeValue }: IsScoreWithinBreakpointProps) {
  const firstBreakpoint = breakpoints[0];
  const lastBreakpoint = breakpoints[breakpoints.length - 1];
  const isWithinBreakpoint = breakpoint.min <= rangeValue && breakpoint.max >= rangeValue;
  const isPastLastBreakpoint = breakpoint.id === lastBreakpoint.id && rangeValue > lastBreakpoint.max;
  const isBeforeFirstBreakpoint = breakpoint.id === firstBreakpoint.id && rangeValue < firstBreakpoint.min;
  return isWithinBreakpoint || isPastLastBreakpoint || isBeforeFirstBreakpoint;
}
